import {
  locationIdFormat,
  processingSessionIdFormat,
} from "@redotech/redo-model/ids";
import * as z from "zod/v4";
import { ProcessingSession_ } from "./processing-session";

export const completeProcessingSession = {
  name: "completeProcessingSession" as const,
  input: z.object({
    sessionId: processingSessionIdFormat.schema,
    locationId: locationIdFormat.schema.optional(),
  }),
  output: z.object({ session: ProcessingSession_ }),
};
